import React from 'react'
import PropTypes from 'prop-types'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

const SearchAddress = ({ locationHandler}) => {
  const [address, setAddress] = React.useState('')

  const _selectHandler = address => {
    setAddress(address)
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(({ lat, lng }) => locationHandler({ address, latitude: lat, longitude: lng }))
      .catch(error => console.error('Error', error)) // eslint-disable-line
  }

  return (
    <PlacesAutocomplete value={address} onChange={setAddress} onSelect={_selectHandler}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="address">
          <input {...getInputProps({ placeholder: 'Search Places...' })} />
          <div className="interactive rows results">
            {loading && <div className="loading">Loading...</div>}
            {suggestions.map((suggestion, index) => (
              <div key={"suggestion-" + index} {...getSuggestionItemProps(suggestion, { className: 'row' })}>
                {suggestion.description}
              </div>
            ))}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  )
}

SearchAddress.propTypes = {
  locationHandler: PropTypes.func.isRequired
}

export default SearchAddress
